export default __webpack_public_path__ + "static/media/image-15.54407245.png";